import Autocomplete from '@mui/material/Autocomplete';
import React from 'react';
import IconButton from '../IconButton';
import { Clear as ClearIcon, ArrowDropDown as ArrowDropDownIcon } from '../Icons/Core';
const BDSAutocomplete = (props) => {
    return (React.createElement(Autocomplete, Object.assign({}, props, { clearIcon: React.createElement(IconButton, { bdsSize: "medium" },
            React.createElement(ClearIcon, null)), popupIcon: React.createElement(IconButton, { bdsSize: "medium" },
            React.createElement(ArrowDropDownIcon, null)) })));
};
export default BDSAutocomplete;
//# sourceMappingURL=Autocomplete.js.map